// Space/Liste ikon kayıt defteri — ClickUp "Color & Icon" seçici için.
// icon string olarak DB'de (rpt_task_space.icon) saklanır, burada lucide bileşenine map edilir.
import {
  Rocket, Zap, Wrench, Cog, ShoppingCart, Truck, Package, Factory, Cpu, Hammer,
  Ruler, PenTool, FileText, ClipboardList, Calendar, Users, Building2, Briefcase,
  Target, Flag, Star, Heart, Bug, FlaskConical, Boxes, Layers, Database, Server,
  Globe, Phone, Mail, Camera, Image, Music, Bike, Car, Plane, Wifi, Bell,
  Bookmark, Book, Award, Gift, Coffee, Anchor, Activity, BarChart3, PieChart,
  Settings, Shield, Lock, Key, Cloud, Sun, Moon, Leaf, Flame, Droplet, Compass,
  Map, Home, Store, Warehouse, CircleDot,
} from 'lucide-react'

// Curated set — anahtar = DB'ye yazılan string
export const SPACE_ICONS = {
  rocket: Rocket, zap: Zap, wrench: Wrench, cog: Cog, cart: ShoppingCart, truck: Truck,
  package: Package, factory: Factory, cpu: Cpu, hammer: Hammer, ruler: Ruler, pen: PenTool,
  file: FileText, clipboard: ClipboardList, calendar: Calendar, users: Users, building: Building2,
  briefcase: Briefcase, target: Target, flag: Flag, star: Star, heart: Heart, bug: Bug,
  flask: FlaskConical, boxes: Boxes, layers: Layers, database: Database, server: Server,
  globe: Globe, phone: Phone, mail: Mail, camera: Camera, image: Image, music: Music,
  bike: Bike, car: Car, plane: Plane, wifi: Wifi, bell: Bell, bookmark: Bookmark, book: Book,
  award: Award, gift: Gift, coffee: Coffee, anchor: Anchor, activity: Activity, bar: BarChart3,
  pie: PieChart, settings: Settings, shield: Shield, lock: Lock, key: Key, cloud: Cloud,
  sun: Sun, moon: Moon, leaf: Leaf, flame: Flame, droplet: Droplet, compass: Compass,
  map: Map, home: Home, store: Store, warehouse: Warehouse,
}

export const SPACE_ICON_KEYS = Object.keys(SPACE_ICONS)

// ClickUp benzeri renk paleti — status + space rengi seçici
export const SPACE_COLORS = [
  '#4B4B4B', '#8B8B8B', '#5B47E0', '#4169E1', '#3B9EFF', '#22C55E',
  '#F5C842', '#F06A2A', '#E5484D', '#EC4899', '#A855F7', '#8B6F52',
]

// Renkten okunur metin (koyu zeminde beyaz) — hep beyaz yeterli bu palette
export function SpaceGlyph({ icon, color, name, size = 18, radius = 'rounded-md' }) {
  const c = color || '#5B47E0'
  const Comp = icon ? SPACE_ICONS[icon] : null
  const box = size + 8
  return (
    <span className={`inline-flex items-center justify-center ${radius} shrink-0 text-white font-semibold`}
      style={{ background: c, width: box, height: box, fontSize: Math.round(size * 0.62) }}>
      {Comp ? <Comp size={size} strokeWidth={2.4} /> : (name || '?').trim().charAt(0).toUpperCase()}
    </span>
  )
}

// CircleDot fallback ihracı (default icon aday)
export { CircleDot }
